// extracted by mini-css-extract-plugin
export default {"container":"Preview_container__m-d6q","previewText":"Preview_previewText__5exqz","previewBody":"Preview_previewBody__8VYlN"};